import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { map } from "rxjs/operators";
import { of } from "rxjs";
import { EdpResponseBody } from "@edp-models/response.model";
import { ApiService } from "@edp-services/api.service";
import { RequestsAndOperations, RequestsAndOperationsFactory } from "@edp-models/requests-and-operations";

@Injectable({
    providedIn: "root",
})
export class RequestsOperationsService {
    private requestsAndOperationsList: RequestsAndOperations[] = [];
    private selectedRequest: RequestsAndOperations;

    private nextListFromCache: boolean;

    constructor(private apiService: ApiService) {}

    public getList = (body: object, fromCache: boolean): Observable<EdpResponseBody> => {
        if (fromCache || this.nextListFromCache) {
            const response: EdpResponseBody = new EdpResponseBody();
            response.Success = true;
            response.Result.Collection = this.requestsAndOperationsList;
            this.nextListFromCache = false;
            return of(response);
        } else {
            return this.apiService.callServicePost("customerSupport.getAll", body, null).pipe<EdpResponseBody>(
                map((response: EdpResponseBody) => {
                    if (response.Result.Collection.length) {
                        response.Result.Collection = response.Result.Collection.map(result => this.createRequest(result));
                        this.requestsAndOperationsList = response.Result.Collection;
                    }
                    return response;
                })
            );
        }
    }

    public getAvailableTimeSlots(serviceObjectId: string, serviceTask: string, serviceType: string): Observable<Error | EdpResponseBody> {
        return this.apiService.callServicePost(
            "customerSupport.getAvailableTimeSlots",
            {
                serviceObjectId,
                serviceTask,
                serviceType,
            },
            null,
            false
        );
    }

    public setNextListFromCache(): void {
        this.nextListFromCache = true;
    }

    public createRequest(requestsAndOperations: any): RequestsAndOperations {
        return RequestsAndOperationsFactory.create({
            Attachments: requestsAndOperations.Attachments,
            Channel: requestsAndOperations.Channel,
            ContactDetail: requestsAndOperations.ContactDetail,
            ContractID: requestsAndOperations.ContractID,
            ContractNumber: requestsAndOperations.ContractNumber,
            CreationDate: requestsAndOperations.CreationDate,
            CustomerName: requestsAndOperations.CustomerName,
            DocumentEnabled: requestsAndOperations.DocumentEnabled,
            ID: requestsAndOperations.ID,
            LastInteractionDate: requestsAndOperations.LastInteractionDate,
            Motive: requestsAndOperations.Motive,
            MotiveAcronym: requestsAndOperations.MotiveAcronym,
            Status: requestsAndOperations.Status,
            Subject: requestsAndOperations.Subject,
            Target: requestsAndOperations.Target,
            Type: requestsAndOperations.Type,
            Service: requestsAndOperations.Service,
            ServiceAcronym: requestsAndOperations.ServiceAcronym,
            ExternalCategory: requestsAndOperations.ExternalCategory,
            DataOrigin: requestsAndOperations.DataOrigin,
            Intervention: requestsAndOperations.Intervention,
            Scheduling: requestsAndOperations.Scheduling,
            Task: requestsAndOperations.Task,
            ObjectId: requestsAndOperations.ObjectId,
        } as RequestsAndOperations);
    }

    public getRequests(): RequestsAndOperations[] {
        return this.requestsAndOperationsList;
    }

    public getSelectedRequest() {
        return this.selectedRequest;
    }

    public selectRequest(request: RequestsAndOperations): void {
        this.selectedRequest = request;
    }

    public get = (args: any): Observable<Error | EdpResponseBody> => {
        return this.apiService.callServicePost("customerSupport.getCustomerSupportItem", args, null);
    }

    public getArgs(localSupport: boolean = false, contractList: string[]): object {
        return {
            list: contractList,
            types: ["PI", "REC", "PO"],
            origin: "customer_support",
            localSupportList: localSupport,
        };
    }

    public setNewRequest(args) {
        return this.apiService.callServicePost("customerSupport.createCustomerSupport", args);
    }

    public getSymptoms(args = {}) {
        return this.apiService.callServicePost("supportEquipments.getSymptoms", args);
    }

    public getEquipments(args = {}) {
        return this.apiService.callServicePost("supportEquipments.getEquipments", args);
    }

    getCustomerSupportItemSolar(solarContractId: string) {
        return this.apiService.callServicePost("customerSupport.getCustomerSupportItemSolar", {
            SolarContractId: solarContractId,
            Target: "CRM",
        });
    }
}
